import React from 'react'
import Scrollbars from 'components/Scrollbars'
import styled from 'styled-components'

type Props = {
  className?: string
}

const StyledScrollbars = styled(Scrollbars)`
  display: flex;
  align-items: center;
  padding: 15px;
  width: 100%;
`

const ViewMenu: React.FC<Props> = ({
  children,
  ...props
}) => {
  return (
    <StyledScrollbars
      {...props}
    >
      {children}
    </StyledScrollbars>
  )
}

export default ViewMenu
